import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientInterface } from '../../client/api/api-client.interface';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';
import { RoleNameInterface } from '../data/role-name.interface';

@Injectable()
export class RoleNameApiRepository {
    constructor(private apiClient: ApiClientInterface, private transactionRequest: TransactionRequestInterface) {}

    load(): Observable<Transaction<RoleNameInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.getRoleName());
    }
}
